import { render, staticRenderFns } from "./AddTipoAcuerdoModal.vue?vue&type=template&id=dcbf22e2"
import script from "./AddTipoAcuerdoModal.vue?vue&type=script&lang=js"
export * from "./AddTipoAcuerdoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports